/*
 * Copyright (c) 2023 Pegasystems Inc.
 * All rights reserved.
 */

import { publicConstants } from '../constants';
import PubSubUtils from '../utils/pubsub-utils';

export default class InactivityTimeout {
  timerID: number | undefined;
  expiryBuffer: number;
  timeoutWarned: boolean;

  constructor() {
    this.timerID = undefined;
    this.expiryBuffer = 45;
    this.timeoutWarned = false;
  }

  setTimerID = (newTimerID?: number) => {
    this.timerID = newTimerID;
  };

  getTimerID = () => {
    return this.timerID;
  };

  resetInactiveTimeout = (timer?: number) => {
    const inactivityTimeout = window.PCore?.getEnvironmentInfo().getInactivityTimeout();
    if (this.timeoutWarned) {
      PubSubUtils.unsubscribe(publicConstants.PUB_SUB_EVENTS.RESET_TIMER, 'resetCallback');
      this.timeoutWarned = false;
    }
    if (!inactivityTimeout) return;
    if (timer) clearTimeout(timer);
    return this.startInactivityTimeout(inactivityTimeout > 60 ? inactivityTimeout : 60);
  };

  startInactivityTimeout = (timeout: number) => {
    const timeoutID = setTimeout(
      () => {
        PubSubUtils.publish(publicConstants.PUB_SUB_EVENTS.TIMEOUT_REMINDER, { timeRemaining: this.expiryBuffer });
        clearTimeout(timeoutID);
        PubSubUtils.subscribe(publicConstants.PUB_SUB_EVENTS.RESET_TIMER, this.resetInactiveTimeout, 'resetCallback');
        this.timeoutWarned = true;
      },
      (timeout - this.expiryBuffer) * 1000
    ) as unknown as number;
    this.setTimerID(timeoutID);
    return timeoutID;
  };
}
